import { render, staticRenderFns } from "./MediaManagementWrapper.vue?vue&type=template&id=4c56906a"
import script from "./MediaManagementWrapper.vue?vue&type=script&lang=js"
export * from "./MediaManagementWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports